module.exports = __webpack_public_path__ + "img/video-02.86bf1da2.png";